export default __webpack_public_path__ + "static/media/info-icon copy.8111201d.svg";